<script>
import moment from "moment/moment";
import Datepicker from "vuejs-datepicker";
import {es} from "vuejs-datepicker/dist/locale";

const end = moment()
    .locale("es")
    .endOf("month")
    .format("YYYY-MM-DD");

export default {
  name: "balances",
  components: {
    Datepicker,
  },
  created() {
    this.rg_start = moment()
        .locale("es")
        .startOf("month")
        .format("YYYY-MM-DD");

    this.rg_end = moment()
        .locale("es")
        .endOf("month")
        .format("YYYY-MM-DD");
  },
  data() {
    return {
      pid: 0,
      contrato: 0,
      rg_start: "2020-12-01",
      rg_end: "2020-12-31",
      es: es,
      rules: [],
      selectedRule: 0,
      loadingRule: false
    }
  },
  methods: {
    downloadCSV() {
      let e = "";
      let start = moment(this.rg_start)
          .add(1, "days")
          .format('YYYY-MM-DD');

      e = this.rg_end !== end ? moment(this.rg_end).add(1, "days").format('YYYY-MM-DD')
          : this.rg_end;

      start = moment(start).startOf("month").format('YYYY-MM-DD');
      e = moment(e).endOf("month").format('YYYY-MM-DD');

      if (start > e) {
        this.missingFieldsNotif(
            "Fechas incongruentes",
            `La fecha de Inicio ${start} de consulta es mayor a la fecha de Fin ${e}`
        );
        return;
      }

      let url = `${process.env.VUE_APP_API_DOMAIN}/api/getRGBalanceCSV?start=${start}&end=${e}&access_token=${this.user.access_token}`;
      window.open(url, '_blank');
    },
  }
}
</script>

<template>
  <div class="col-sm-12 col-md-6 col-lg-6 mx-auto mt-10">
    <vx-card title="Balance RedGirasol">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <label for="start">Inicio</label>
          <datepicker
              class="w-full"
              name="start"
              v-model.lazy="rg_start"
              description="Fecha Inicio"
              :language="es"
              :use-utc="true"
              :minimumView="'month'"
              :maximumView="'month'"
              format="MMM yyyy"/>
        </div>
        <div class="col-md-4 col-sm-12">
          <label for="end">Fin</label>
          <datepicker
              class="w-full"
              description="Fecha Fin"
              name="end"
              v-model.lazy="rg_end"
              :language="es"
              :use-utc="true"
              :minimumView="'month'"
              :maximumView="'month'"
              format="MMM yyyy"/>
        </div>
        <div class="col-md-4 col-sm-12">
          <vs-button @click="downloadCSV()" style="margin-top: 2rem;" color="warning" size="small">
            Generar CSV
          </vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<style scoped>

</style>